function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "1024-768-start",
  transform: "translate(-16.000000, -16.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Pic",
  transform: "translate(16.000000, 16.000000)"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "#FE7F8A",
  x: 0,
  y: 0,
  width: 32,
  height: 32,
  rx: 7
}), React.createElement("path", {
  d: "M15.8403166,11.0023891 C18.85315,11.0023891 21.29565,13.4372151 21.29565,16.4407267 C21.29565,19.4442385 18.85315,21.8790644 15.8403166,21.8790644 C12.8274,21.8790644 10.3849,19.4442385 10.3849,16.4407267 C10.3849,13.4372151 12.8274,11.0023891 15.8403166,11.0023891",
  id: "Fill-4",
  fill: "#FFFFFF"
}), React.createElement("path", {
  d: "M6.73160945,8 C6.32822113,8 6,8.31582702 6,8.70385882 L6,24.2961413 C6,24.6842648 6.32822113,25 6.73160945,25 L25.2683013,25 C25.6717789,25 26,24.6842648 26,24.2961413 L26,8.70385882 C26,8.31582702 25.6717789,8 25.2683013,8 L6.73160945,8 Z M6.76052622,26 C5.7897746,26 5,25.2117507 5,24.2425874 L5,8.75741265 C5,7.78834048 5.7897746,7 6.76052622,7 L25.2394738,7 C26.2103143,7 27,7.78834048 27,8.75741265 L27,24.2425874 C27,25.2117507 26.2103143,26 25.2394738,26 L6.76052622,26 Z",
  id: "Fill-6",
  stroke: "#1A1A1A",
  strokeWidth: 0.4,
  fill: "#1A1A1A"
}), React.createElement("path", {
  d: "M22.5113834,5.63611792 C23.3932166,5.63611792 24.1081334,6.34917766 24.1081334,7.22872052 C24.1081334,8.10826337 23.3932166,8.82124 22.5113834,8.82124 C21.62955,8.82124 20.9147166,8.10826337 20.9147166,7.22872052 C20.9147166,6.34917766 21.62955,5.63611792 22.5113834,5.63611792",
  id: "Fill-8",
  fill: "#FFFFFF"
}))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.9561623f.svg";
export { ForwardRef as ReactComponent };